import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import router from '@/router'

import authorization from './plugins/auth'
import api from './plugins/api'

import notify from '@ananasbear/notify'
import validate from '@ananasbear/validation'
import i18n from '@/plugins/vue-i18n'
import Table from '@/components/layouts/Table'
import Loader from '@/components/Loader'
import Vuelidate from 'vuelidate'
import Vuesax from 'vuesax'
import device from 'vue-device-detector'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueMask from 'v-mask'
import VueMeta from 'vue-meta'
import PageTemplate from '@/components/PageTemplate'
import UiIcon from '@/components/ui/Icon'
import UiModal from '@/components/ui/Modal'

import directusTranslation from '@/plugins/directus-translation'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import VueGtag from 'vue-gtag'

import 'vuesax/dist/vuesax.css'
Vue.use(Vuesax)
Vue.use(VueMask)

Vue.component('Table', Table)
Vue.component('Loader', Loader)
Vue.component('QrCode', VueQRCodeComponent)
Vue.component('PageTemplate', PageTemplate)
Vue.component('UiIcon', UiIcon)
Vue.component('UiModal', UiModal)
Vue.use(Vuelidate)
Vue.use(VueMeta)
Vue.use(device)
Vue.use(directusTranslation)

// Styles
import '@/assets/sass/fonts.sass'
import '@/assets/sass/components/buttons.sass'
import '@/assets/sass/constants.sass'
import '@/assets/sass/language.sass'
import '@/assets/sass/components/modal.sass'
import '@/assets/sass/components/slider.sass'

import '@/assets/css/style.css'
import '@/assets/sass/main.sass'
import '@/assets/sass/components/dashboard.sass'
import '@/assets/sass/pages/Payment.sass'

Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
      params: {
        send_page_view: false
      }
    }
  },
  router
)

Vue.config.productionTip = false

dayjs.extend(utc)
dayjs.extend(timezone)
Vue.prototype.$dayjs = dayjs

Vue.prototype.$notification = notify
Vue.prototype.$api = api
Vue.prototype.$auth = authorization
Vue.prototype.$valid = validate

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
